module.exports = __webpack_public_path__ + "static/img/2.6aa036b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Images/2.jpg
// module id = 5K+n
// module chunks = 0